import { useState } from "react";
import Swal from "sweetalert2";
import api from "../../services/api.js";

export default function CloseServiceModal({
  open,
  onClose,
  serviceId,
  token,
  onSuccess,
}) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      return Swal.fire(
        "Validasi gagal",
        "Alasan terminasi wajib diisi",
        "warning"
      );
    }

    setLoading(true);
    try {
      const res = await api.put(
        `/subscribe/${serviceId}`,
        {
          suspensionreason: reason,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      Swal.fire("Berhasil", res.data.message, "success");

      setReason("");
      onClose();
      onSuccess?.();
    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        error.response?.data?.message || "Gagal menutup service",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg dark:bg-gray-900">
        <h2 className="mb-4 text-lg font-semibold text-gray-800 dark:text-gray-100">
          Terminasi Service
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm text-gray-600 dark:text-gray-300">
              Terminate Reason
            </label>
            <textarea
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="
                w-full rounded-lg border border-gray-300 bg-white p-3 text-sm
                text-gray-800 focus:border-red-500 focus:outline-none
                focus:ring-1 focus:ring-red-500
                dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100
              "
              placeholder="Contoh: Customer berhenti berlangganan"
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="
                rounded-lg px-4 py-2 text-sm
                text-gray-700 hover:bg-gray-100
                dark:text-gray-300 dark:hover:bg-gray-800
              "
              disabled={loading}
            >
              Batal
            </button>

            <button
              type="submit"
              disabled={loading}
              className="
                rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white
                hover:bg-red-700 disabled:opacity-50
              "
            >
              {loading ? "Memproses..." : "Terminate"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
